import { defineStore } from 'pinia'
import { useRequest } from 'composables/useRequest.js'

// Static reference catalog (name + description + logo_url) used to power
// autocomplete suggestions when creating an org application. It never changes
// per user or organization, so it's fetched once per session and reused from then on.
export const useGlobalApplicationsStore = defineStore('globalApplications', {
  state: () => ({
    applications: [],
    loading: false,
    fetched: false,
  }),

  actions: {
    async fetchIfNeeded() {
      if (this.fetched || this.loading) return
      this.loading = true
      try {
        const { axiosRequest } = useRequest()
        const res = await axiosRequest('GET', '/api/v1/global_applications', {}, false)
        if (!res.js_error && res.response.success) {
          this.applications = res.response.data
          this.fetched = true
        }
      } finally {
        this.loading = false
      }
    },
  },
})
